export function getValue(target: any, path: any): any {
    if (!target) {
        return;
    }

    if (!Array.isArray(path)) {
        console.warn('getValue', 'empty path');
        return;
    }

    const _path = [...path];
    const step = _path.shift();

    if (!target[step] || !_path.length) {
        return target[step];
    }

    return getValue(target[step], _path);
}
